import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { graphql } from '@apollo/client/react/hoc';
import { titleize } from 'util/strings';
import BuildingCard from 'components/cards/BuildingCard';
import Spinner from 'components/Spinner';
import BuildingListQuery from 'queries/BuildingListQuery.gql';
import styles from './style.module.scss';

const RECORDS_PER_PAGE = 32;

class BuildingListPage extends Component {
  generatePaginatedLinks = () => {
    const {
      state,
      city,
      neighborhood,
      page: pageParam,
    } = this.props.match.params;
    const pageParts = ['/buildings', state, city, neighborhood]
      .filter((f) => f)
      .join('/');
    const currentPage = parseInt(pageParam, 10) || 1;
    const prevPageNumber = currentPage - 1;
    const nextPageNumber = currentPage + 1;

    return {
      canonical: `${pageParts}${currentPage < 2 ? '' : `/${currentPage}`}`,
      previous: `${pageParts}${prevPageNumber < 2 ? '' : `/${prevPageNumber}`}`,
      next: `${pageParts}/${nextPageNumber}`,
    };
  };

  render() {
    const {
      state,
      city,
      neighborhood,
      page: pageParam,
    } = this.props.match.params;
    const page = parseInt(pageParam, 10) || 1;
    const hasBuildings =
      this.props.data &&
      this.props.data.buildings &&
      this.props.data.buildings.length > 0;
    const showsNextPageLink =
      this.props.data &&
      this.props.data.buildings &&
      this.props.data.buildings.length === RECORDS_PER_PAGE;
    const showsPreviousPageLink = page > 1;
    const paginatedLinks = this.generatePaginatedLinks();
    const lowItemNumber = (page - 1) * RECORDS_PER_PAGE;
    let highItemNumber = lowItemNumber;
    if (this.props.data && this.props.data.buildings)
      highItemNumber += this.props.data.buildings.length;

    const breadcrumb = (
      <p className={styles.breadcrumb}>
        <span>
          Showing items {lowItemNumber + 1} - {highItemNumber}
        </span>
        {showsNextPageLink && <Link to={paginatedLinks.next}>Next Page</Link>}
        {showsPreviousPageLink && (
          <Link to={paginatedLinks.previous}>Previous Page</Link>
        )}
      </p>
    );
    let location = `${titleize(city)}, ${state.toUpperCase()}`;
    if (neighborhood) location = `${neighborhood}, ${location}`;
    const description = `Browse through all of the commercial buildings in ${location}, and find an office space that suits your business.`;

    return (
      <div>
        <Helmet>
          <meta name="description" content={description} />
          {showsPreviousPageLink && (
            <link rel="prev" href={paginatedLinks.previous} />
          )}
          {showsNextPageLink && <link rel="next" href={paginatedLinks.next} />}
          {!hasBuildings && <meta name="robots" content="noindex" />}
          <link rel="canonical" href={paginatedLinks.canonical} />
        </Helmet>
        {!this.props.data.loading && breadcrumb}
        {this.props.data.loading && <Spinner />}
        <ul className="cards">
          {this.props.data &&
            this.props.data.buildings &&
            this.props.data.buildings.map((b) => (
              <BuildingCard key={b.slug} building={b} />
            ))}
        </ul>
        {!this.props.data.loading && breadcrumb}
      </div>
    );
  }
}

export default graphql(BuildingListQuery, {
  options: (props) => ({
    variables: {
      city: props.match.params.city,
      state: props.match.params.state,
      neighborhood: props.match.params.neighborhood,
      offset: ((props.match.params.page || 1) - 1) * RECORDS_PER_PAGE,
      limit: RECORDS_PER_PAGE,
    },
  }),
})(BuildingListPage);
